// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2fqGO","tab":"ProcedureTabs_tab__31XNX"};